import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'

export const SALE_DETAIL_PAGES_FETCHER = Symbol('SALE_DETAIL_PAGES_FETCHER')

export type SaleDetailPagesResult = Promise<Map<string, string>>

export interface SaleDetailPagesFetcher {
  getSaleDetailPages(keys: string[], endpoint: string): SaleDetailPagesResult
}


@registerDependency(FAKE, SALE_DETAIL_PAGES_FETCHER)
export class FakeSaleDetailPagesFetcher implements SaleDetailPagesFetcher {
  data: Map<string, string>
  lastRequestedUrl: string | undefined

  constructor() {
    this.data = new Map()
  }

  getSaleDetailPages(keys: string[], endpoint: string): SaleDetailPagesResult {
    this.lastRequestedUrl = endpoint
    endpoint
    const result: Map<string, string> = new Map()
    keys.forEach(key => {
      const foundKey = this.data.get(key)
      if (foundKey) {
        result.set(key, foundKey)
      }
    })
    return Promise.resolve(result)
  }

  insertUrl(sale_token: string, url: string) {
    this.data.set(sale_token, url)
  }

}


@registerDependency(REAL, SALE_DETAIL_PAGES_FETCHER)
export class RealSaleDetailPagesFetcher implements SaleDetailPagesFetcher {
  async getSaleDetailPages(keys: string[], endpoint: string): SaleDetailPagesResult {
    const url = new URL(endpoint, window.location.href)
    for (const key of keys) {
      url.searchParams.append('sale_tokens', key)
    }
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    })

    const json_data= await response.json()
    const result: Map<string, string> = new Map()
    keys.forEach(key => {
      const foundKey = json_data[key]
      if (foundKey !== undefined) {
        result.set(key, foundKey)
      }
    })
    return Promise.resolve(result)
  }
}
